import React from 'react'
import { CheckCircle, AlertCircle } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { integrationUtils } from '@/features/integrations/utils/integrationUtils'
import type { JobberIntegration } from '@/features/jobber/types'

interface JobberStatusCardProps {
  integration?: JobberIntegration
  onConnect: () => void
}

export function JobberStatusCard({ integration, onConnect }: JobberStatusCardProps) {
  const isConnected = integration?.status === 'connected' || integration?.status === 'syncing'

  if (isConnected && integration) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <CheckCircle className={`w-5 h-5 ${integration.status === 'syncing' ? 'text-accent' : 'text-chart-5'}`} />
            {integration.status === 'syncing' ? 'Jobber CRM Syncing' : 'Jobber CRM Connected'}
          </CardTitle>
          <CardDescription>
            Last synced: {integration.last_sync ? integrationUtils.formatRelativeTime(integration.last_sync) : 'Never'}
          </CardDescription>
        </CardHeader>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent className="p-12 text-center">
        <AlertCircle className="w-12 h-12 text-accent mx-auto mb-4" />
        <h3 className="text-lg font-semibold mb-2">No Jobber Integration</h3>
        <p className="text-muted-foreground mb-4">
          Connect your Jobber CRM account to start syncing customer data and jobs.
        </p>
        <Button onClick={onConnect}>Connect Jobber CRM</Button>
      </CardContent>
    </Card>
  )
}
